'use client'

import * as React from 'react'

import type { MediaType } from './types'
import { InteractiveGallery } from './interactive-gallery'

interface GalleryBlockFields {
  blockType: 'gallery'
  images?: {
    image?: MediaType | string
    id?: string
  }[]
  description?: string
}

interface GalleryBlockProps {
  fields: GalleryBlockFields
}

export function GalleryBlock({ fields }: GalleryBlockProps) {
  if (!fields.images?.length) return null

  return <InteractiveGallery images={fields.images} description={fields.description} />
}
